import { css } from "styled-components"

export const boxShadow = {
  normal: css`
    box-shadow: 0 6px 12px rgb(0 0 0 / 6%);
  `,
} as const
